import { Component, OnInit } from '@angular/core';
import { PopoverController } from '@ionic/angular';

@Component({
  selector: 'app-popticket',
  templateUrl: './popticket.component.html',
  styleUrls: ['./popticket.component.scss'],
})
export class PopticketComponent implements OnInit {

  constructor(
    public popoverController: PopoverController
  ) { }

  ngOnInit() {}

  closePopover(btn = null){
    this.popoverController.dismiss({
      'btn': btn
    });
  }

}
